/*eslint no-undef: 0*/

import { getStorageItem, setStorageItem, removeStorageItem } from './storage';

/**
 *
 * @param {Object} nextState
 * @param {function} replace
 */
export function requireAuth(nextState, replace) {
  if (!getIsAuthenticated()) {
    replace('/');
  }
}

/**
 *
 * @param {Object} nextState
 * @param {function} replace
 */
export function requireGuest(nextState, replace) {
  if (getIsAuthenticated()) {
    replace('/');
  }
}

/**
 *
 * @param {Object} session
 */
export function setSession(session) {
  setStorageItem('auth_session', session);
}

/**
 *
 * @param {Object} user
 */
export function setUser(user) {
  setStorageItem('auth_user', user);
}
/**
 *
 * @returns {Object}
 */
export function getSession() {
  return getStorageItem('auth_session');
}
/**
 *
 * @returns {Object}
 */
export function getUser() {
  return getStorageItem('auth_user');
}

/**
 *
 */
export function removeSession() {
  removeStorageItem('auth_session');
}

/**
 *
 */
export function removeUser() {
  removeStorageItem('auth_user');
}

/**
 *
 * @returns {boolean}
 */
export function getIsAuthenticated() {
  return Boolean(getToken());
}

/**
 *
 * @returns {string|null}
 */
export function getToken() {
  return getStorageItem('auth_session.token');
}



/** WEBPACK FOOTER **
 ** ./src/helpers/auth.js
 **/